import React from 'react'
import { StyleSheet } from 'react-native'

import { DNABox, Stack, DNAText, DNAButton } from '@alucio/lux-ui';

import { useHubsState } from 'src/state/context/Hubs/HubsStateProvider'
import BeaconEmptyStateImage from 'src/assets/images/BeaconEmptyState'

const S = StyleSheet.create({
  labelText: {
    fontSize: 15,
    color: '#64748B',
    fontWeight: '600',
  },
})

const HubsTemplateEmptyState: React.FC = () => {
  const { handleCreateHubs } = useHubsState()
  return (
    <DNABox fill>
      <Stack anchor="center">
        {/* IMAGE */}
        <Stack.Layer anchor="center" alignSelf="center">
          <BeaconEmptyStateImage
            height={320}
            width={320}
          />
        </Stack.Layer>
        {/* LABEL & ACTION BUTTON */}
        <Stack.Layer anchor="bottom">
          <DNABox appearance="col" alignX="center" spacing="lg">
            <DNAText testID="empty-content-placeholder" style={S.labelText}>
              Create your first hub template
            </DNAText>
            <DNAButton
              testID="hub-template-empty-state-create-template-btn"
              onPress={() => handleCreateHubs()}
              children="Create template"
            />
          </DNABox>
        </Stack.Layer>
      </Stack>
    </DNABox>
  )
}

export default HubsTemplateEmptyState
